window.addEventListener('OpusCartChange', (event) => {
  const interval = setInterval(() => {
    const checkoutBtn = document.querySelector('#opus-checkout-btn');

    if (checkoutBtn && !checkoutBtn.parentNode.querySelector('.return-policy')) {
      const textSpan = document.createElement('span');
      textSpan.classList.add('return-policy');
      textSpan.textContent = 'Free 30-day returns – hassle-free and guaranteed';
      textSpan.style.display = 'flex';
      textSpan.style.fontSize = '16px';
      textSpan.style.justifyContent = 'center';
      textSpan.style.marginBottom = '8px'; 

      checkoutBtn.parentNode.insertBefore(textSpan, checkoutBtn); 
      clearInterval(interval);
    }
  }, 500);
});

